import { Locale, Translation } from 'locale'
import React from 'react'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { withModal } from 'view/shared/modal'
import { PrimeBrokerDefaultsAddDialog } from './PrimeBrokerDefaultsAddDialog'

export const PrimeBrokerDefaultsToolbar = withModal(props => {
  const openPrimeBrokerDialog = () => {
    props.showModal(<PrimeBrokerDefaultsAddDialog />)
  }

  return (
    <TextButton
      dataTestId={'PrimeBrokerDefaultsToolbar-TextButton-AddPrimeBroker'}
      type={TextButtonType.Primary}
      onClick={openPrimeBrokerDialog}>
      {Locale.translate(Translation.TC_BUTTON_NEW_PRIME_BROKER)}
    </TextButton>
  )
})
